import { useState, useEffect } from "react";
import { z } from "zod";
import logoLeft from "../../assets/logo.svg";
import logoWhite from "../../assets/logoWhite.svg";
import drawingbottom from "../../assets/undraw_my_password.svg";
import emailIcon from "../../assets/envelope 1.png";
import passwordIcon from "../../assets/cadeado.png";
import ButtonForm from "../../components/ButtonForm";
import api from "../../services/api";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import SpinnerLoading from "../../components/SpinnerLoading";

const Login = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const token =
      localStorage.getItem("token") || sessionStorage.getItem("token");
    if (token) {
      navigate("/dashboard"); // Redireciona para o dashboard se já estiver logado
    }
  }, [navigate]);

  // Definindo o schema com zod
  const schema = z.object({
    email: z.string().email("E-mail inválido").min(1, "E-mail é obrigatório"),
    password: z
      .string()
      .min(4, "A senha deve ter pelo menos 6 caracteres")
      .min(1, "Senha é obrigatória"),
  });

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [errors, setErrors] = useState({});

  const handleSumbit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    // Validando os dados com o zod
    const result = schema.safeParse({ email, password });

    if (!result.success) {
      const formattedErrors = {};
      result.error.errors.forEach((err) => {
        formattedErrors[err.path[0]] = err.message;
      });
      setErrors(formattedErrors);
      return;
    }
    try {
      const response = await api.post("/login", {
        email: result.data.email,
        password: result.data.password,
      });

      const token = response.data.token;

      if (rememberMe === true) {
        localStorage.setItem("token", token);
      } else if (rememberMe === false) {
        sessionStorage.setItem("token", token);
      }

      const userData = response.data.user;
      login(userData);

      navigate(userData.accessType === "AGENT" ? "/cargas" : "/dashboard");
    } catch (error) {
      setError(error.response.data.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex w-full h-screen bg-white p-12">
      <div className="w-full relative grid-cols-2">
        <div className="bg-[#F2F2F2] flex justify-center h-full rounded-3xl relative z-0">
          <div className="w-[50%] absolute top-0 left-0 z-10 h-full flex flex-col justify-between">
            <div className="flex h-80 justify-center items-center">
              <img
                className="w-[140px] h-[119px] md:w-[140px] md:h-[119px] lg:w-[160px] lg:h-[136px] xl:w-[180px] xl:h-[153px] 2xl:w-[196px] 2xl:h-[166px] object-contain"
                alt="logo"
                src={logoLeft}
              />
            </div>
            <div className="flex justify-center items-end px-[32px]">
              <img
                alt="logo"
                className="w-[300px] h-[292px] sm:w-[300px] sm:h-[292px] md:w-[340px] md:h-[331px] lg:w-[380px] lg:h-[369px] xl:w-[420px] xl:h-[409px] 2xl:w-[460px] 2xl:h-[448px] object-contain"
                src={drawingbottom}
              />
            </div>
          </div>
        </div>
        <div className="bg-[#FF9533] w-[50%] h-full rounded-3xl absolute top-0 right-0 z-10 ">
          <div className="w-full flex justify-center mx-auto h-full">
            <div className="md:w-[70%] lg:w-[70%] xl:w-[60%] 2xl:md-[50%]">
              <div className="justify-center flex h-80 items-center">
                <div className=" justify-center w-[120px] h-[102px] 2xl:h-[166px] xl:h-[153px] lg:h-[136px] md:h-[119px] flex items-center">
                  <img
                    className="flex justify-center  w-[60px] h-[70px] md:w-[70px] md:h-[82px] lg:w-[80px] lg:h-[94px] xl:w-[90px] xl:h-[105px] 2xl:w-[100px] 2xl:h-[117px] object-contain"
                    alt="logo"
                    src={logoWhite}
                  />
                </div>
              </div>
              <div>
                <h2 className="text-center text-white 2xl:text-2xl xl:text-xl text-xl mb-8 font-light">
                  Olá! Bem, vindo de volta
                </h2>

                <form onSubmit={handleSumbit}>
                  <label className="text-base text-white">E-mail</label>
                  <div className="flex items-center w-full h-12 bg-white border border-[#E5E5E5] rounded-lg transition duration-300 ease-in-out hover:shadow-md focus-within:shadow-md mb-3 mt-2">
                    <div className="flex justify-center items-center w-12 border-r border-[#E5E5E5]">
                      <img
                        className="h-[21px] w-[21px]"
                        alt="email-icon"
                        src={emailIcon}
                      />
                    </div>
                    <input
                      onChange={(e) => {
                        setEmail(e.target.value);
                      }}
                      value={email}
                      className="flex w-full px-4 text-base text-gray-700 placeholder-gray-400 focus:outline-none"
                      placeholder="Insira seu e-mail"
                      type="email"
                      required
                    />
                  </div>
                  {errors.email && (
                    <p className="text-red-500 my-3 font-bold">
                      {errors.email}
                    </p>
                  )}
                  {error && (
                    <p className="text-red-500 my-3 font-bold">{error}</p>
                  )}

                  <label className="text-base text-white">Password</label>
                  <br />
                  <div className="flex items-center w-full h-12 bg-white border border-[#E5E5E5] rounded-lg transition duration-300 ease-in-out hover:shadow-md focus-within:shadow-md mb-3 mt-2">
                    <div className="flex justify-center items-center w-12 border-r border-[#E5E5E5]">
                      <img
                        className="h-[21px] w-[21px]"
                        alt="email-icon"
                        src={passwordIcon}
                      />
                    </div>
                    <input
                      onChange={(e) => {
                        setPassword(e.target.value);
                      }}
                      value={password}
                      className="flex w-full px-4 text-base text-gray-700 placeholder-gray-400 focus:outline-none"
                      placeholder="********"
                      type="password"
                      required
                    />
                  </div>
                  {errors.password && (
                    <p className="text-red-500 my-3 font-bold">
                      {errors.password}
                    </p>
                  )}

                  <div className="flex items-center mb-4">
                    <input
                      type="checkbox"
                      checked={rememberMe}
                      onChange={() => setRememberMe(!rememberMe)}
                      id="rememberMe"
                      className=" mr-2 h-5 w-5 border border-white rounded-sm checked:bg-blue-500 focus:outline-none"
                    />
                    <label
                      // htmlFor="rememberMe"
                      className="text-base text-white"
                    >
                      Lembrar esse usuário
                    </label>
                  </div>

                  <ButtonForm
                    type="submit"
                    className="bg-white font-bold uppercase text-base text-[#FF9533] h-12 w-full"
                  >
                    {isLoading ? (
                      <SpinnerLoading>Entrando...</SpinnerLoading>
                    ) : (
                      "Entrar"
                    )}
                  </ButtonForm>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
